import * as types from './constants';

const initialState = {
  data: {},
  raw: null,
  getLoading: false,
  errors_api: {}
};

const actions = {
  // Swagger
  [types.GET_SWAGGER_REQUEST]: state => {
    const data = {
      ...state,
      getLoading: true
    };

    return { ...data };
  },

  [types.GET_SWAGGER_DONE]: (state, { payload }) => {
    const data = {
      ...state,
      getLoading: false,
      data: payload.data,
      raw: payload.raw
    };

    return { ...data };
  },

  [types.GET_SWAGGER_FAILED]: state => {
    const data = {
      ...state,
      getLoading: false
    };

    return { ...data };
  }
};

export default (state = initialState, action) => {
  if (actions[action.type]) return actions[action.type](state, action);
  return state;
};

